module.exports = __webpack_public_path__ + "static/img/strona_009.a2402b1a.jpg";